import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AtmosphereProvider } from './atmosphere/AtmosphereProvider.js';
import { AuthGate } from './auth/AuthGate.js';
import { WorldView } from './world/WorldView.js';

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false } },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AtmosphereProvider>
        <AuthGate>
          <main className="h-full">
            <WorldView />
          </main>
        </AuthGate>
      </AtmosphereProvider>
    </QueryClientProvider>
  );
}
